export default __webpack_public_path__ + "static/media/gradient-shadow-top.cee8f5ff.svg";